import { render, staticRenderFns } from "./AddLevelDialog.vue?vue&type=template&id=5c812019&scoped=true"
import script from "@/views/Levels/AddLevelDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Levels/AddLevelDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Levels/add-level-dialog.scss?vue&type=style&index=0&id=5c812019&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c812019",
  null
  
)

export default component.exports